import { epworthOptions, EpworthResponseType } from "src/revamp/types/PatientFormTypes";
import { z } from "zod";

/**
 * Sleep Medicine History validation schema
 * Validates the entire sleep medicine history category
 */

const responseDetailSchema = z.object({
  response: z.boolean(),
  description: z.string().optional(),
});

const sleepQuestionnaireValidation = z.object({
	averageHoursSlept: z.string(),
	averageMinutesToDoze: z.string(),
	numberOfAwakenings: z.string(),
	sleepBehaviors: z.array(z.string()),
	personalSleepHistory: z.array(z.string()),
	averageBedtime: z.string(),
	averageRiseTime: z.string(),
	sleepStatus: z.string(),
});

const epworthResponseValidation = z.string().refine(
  (val) => epworthOptions.includes(val as EpworthResponseType),
  { message: "Invalid response" }
);

const epworthSleepinessScaleValidation = z.object({
	reading: epworthResponseValidation,
	watchingTV: epworthResponseValidation,
	inactivePublic: epworthResponseValidation,
	passenger: epworthResponseValidation,
	afternoonLayDown: epworthResponseValidation,
	talking: epworthResponseValidation,
	afterLunch: epworthResponseValidation,
	inTraffic: epworthResponseValidation,
	score: z.number(),
});

export const sleepMedicineHistoryValidation = z.object({
  pastSleepStudy: responseDetailSchema.extend({
    document: z.union([z.string(), z.instanceof(File)]).optional(),
  }),
  isOnPAP: z.boolean(),
  papVendor: z.string().optional(),
  drowsinessAccident: responseDetailSchema,
  sleepQuestionnaire: sleepQuestionnaireValidation,
  epworthSleepinessScale: epworthSleepinessScaleValidation,
});

export default sleepMedicineHistoryValidation;
